import {Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../helper/PersianNumberFormat";

const TableTdDateTime = ({dateTime}) => {

  return (
    <div className="flex flex-col justify-center px-4">
      <Typography color="blue-gray">
        {persianNumberFormat(dateTime !== null ? dateTime.split(" ")[0] : "")}
      </Typography>
      {dateTime !== null &&
      <Typography color="blue-gray">
        {persianNumberFormat(dateTime.split(" ")[1])}
      </Typography>
      }
    </div>
  );
};

export default TableTdDateTime;
